<div *ngIf="driver" class="p-4 flex justify-between align-middle">
  <div class="text-base font-semibold">{{fullName}}</div>
  <app-close-button class="self-center" (close)="onClose()"></app-close-button>
</div>

